var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelpFillinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-.859-10h1.464c0-1.322.445-1.881 1.209-2.56.843-.745 1.686-1.728 1.686-3.203C15.5 6.39 14.227 5 12.032 5 9.805 5 8.484 6.44 8.5 8.644l1.607.254c-.127-1.322.652-2.356 1.877-2.356.97 0 1.814.712 1.814 1.848 0 1.08-.59 1.614-1.24 2.203-.074.067-.15.134-.224.204-.923.864-1.193 1.474-1.193 3.203ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
})));
export default SvgHelpFillinline;